import 'twin.macro';
import React from 'react';
/* eslint-disable react/no-array-index-key,jsx-a11y/control-has-associated-label */
import { Row } from './types';
import { EDTPDFSettings } from '@teetsh/app/src/types/edt';

interface Props {
  dayRow: Row;
  settings: EDTPDFSettings;
  classroomRow: Row;
}

export function Head({ dayRow, classroomRow, settings }: Props) {
  const { disableClassroomBar } = settings;
  return (
    <thead style={{ fontSize: `${settings.fontSize}px` }}>
      <tr>
        <th style={{ width: '8rem' }} key={dayRow.title} />
        {dayRow.cells.map((cell, index) => (
          <th tw="text-center" colSpan={cell.colspan} key={index}>
            {cell.title}
          </th>
        ))}
      </tr>
      {!disableClassroomBar && (
        <tr>
          <th key={classroomRow.title} />
          {classroomRow.cells.map((cell, index) => (
            <th tw="text-center" colSpan={cell.colspan} key={index}>
              {cell.title}
            </th>
          ))}
        </tr>
      )}
    </thead>
  );
}
